import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Loader.module.styl";

function Loader({ size, position, text, className, testName }) {

    const sizeClass = styles["size_" + size];
    const positionClass = styles["position_" + position];
    const rootClass = cx(positionClass, className);
    const spinnerClass = cx(styles.loader, sizeClass);

    return (
        <div className={rootClass}>
            <div className={styles.content}>
                <div className={spinnerClass} />
                {text && <div className={styles.text} data-test-name={testName}>{text}</div>}
            </div>
        </div>
    );
}

Loader.propTypes = {
    size: PropTypes.oneOf(["full", "small"]),
    position: PropTypes.oneOf(["block", "centered", "margin-auto"]),
    text: PropTypes.string,
    className: PropTypes.string,
    testName: PropTypes.string,
};

Loader.defaultProps = {
    size: "full",
    position: "block",
};

export default Loader;
